import React from 'react'
import Header from '../components/Header'
import NoticiasTable from '../components/NoticiasTable'

function News() {
  return (

    <div>
      <Header />
      <NoticiasTable />
    </div>
  )
}

export default News